module.exports = __webpack_public_path__ + "static/media/freshdesk_icon.b4d8bd66.svg";